<template>
  <div>
    <vue-apex-charts
       ref="refDonutChartPedido"
       type="pie"
       height="350"
       layout="compact"
       :options="chartOptions"
       :series="validSeries"
    />
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import apexChatData from './apexChartData';

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardTitle,
    BCardSubTitle,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      apexChatData,
    };
  },
  computed: {
    validSeries() {
      const validData = (this.optionData?.series || []).filter((_, index) => this.optionData?.labels?.[index] != null);
      return validData;
    },
    chartOptions() {
      const labels = this.optionData?.labels || [];
      const validLabels = labels.map((label) => label ?? 'Sem classificação');

      return {
        labels: validLabels,
        noData: {
          text: 'Sem dados disponíveis',
          align: 'center',
          verticalAlign: 'middle',
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (value) => value.toLocaleString('pt-BR'),
          },
        },
      };
    },
  },
  methods: {
    atualizarGraficoPedido() {
      this.$nextTick(() => {
        console.log('SERIES: ', this.validSeries);
        console.log('LABELS: ', this.chartOptions.labels);
        console.log('CHART OPTIONS: ', this.chartOptions);
      });
    },
  },
};
</script>
